export const CALCULATOR_ENDPOINTS = {
    offering: '/loan-application/offering',
    calculate: '/loan-application/calculate',
};
